import { MdmPolicyCommand } from "@devices/types";
import { Collapse } from "@mui/material";
import { MinimalTableDetailsRow } from "@shared/table/CollapsibleRow";

import { useStyles } from "./PolicyCommandItem.style";

type Props = {
    policyCommand: MdmPolicyCommand;
    index: number;
    open: number;
};

export const PolicyCommandDetails = ({ policyCommand, index, open }: Props) => {
    const { classes } = useStyles();

    return (
        <MinimalTableDetailsRow colSpan={6} cellClassName={classes.customCollapse} cellStyle={{ padding: "0 16px" }}>
            <Collapse in={open === index} timeout="auto" unmountOnExit>
                <div className={classes.collapsingRowContent}>
                    <br />
                    <div>
                        <pre>{JSON.stringify(policyCommand, null, 2)}</pre>
                    </div>
                </div>
            </Collapse>
        </MinimalTableDetailsRow>
    );
};
